import React from 'react';

export function getPropertyName(schema, key = '') {
  /* 
  key = '.[property].[property]'
  */
  let name = '';
  for (let level of key.split('.')) {
    if (level && level !== 'root') {
      schema = schema.properties[level];
      name += schema.title + ' ';
    }
  }
  return name;
}

function traverseErrorSchema(errorSchema, schema) {
  /*
  {
    __errors: ['xxx'],
    [property]: {
      __errors: ['xxx']
    }
  }
  */

  const {__errors, ...fields} = errorSchema;
  let result = [];
  if (Array.isArray(__errors)) {
    const title = schema?.title;
    result.push(
      (title && title + ' : ') +
        (Array.isArray(__errors) && __errors.join(',')),
    );
  }
  for (let f in fields) {
    const subSchema = schema?.properties?.[f];
    result = result.concat(traverseErrorSchema(fields[f], subSchema));
  }
  return result;
}

export function ErrorList({errors, errorSchema, schema, uiSchema}) {
  return (
    <ul className="form-error-list">
      {/* parse 2 way because rjsf output 2 type errors */}
      {errors[0]?.property
        ? errors.map((it, idx) => (
            <li key={idx}>
              {getPropertyName(schema, it.property)}: {it?.message}
            </li>
          ))
        : traverseErrorSchema(errorSchema, schema).map((it, idx) => {
            return <li key={idx}>{it}</li>;
          })}
    </ul>
  );
}

export function scrollToTop() {
  if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
}

export function transformErrors(errors) {
  return errors.map((e) => {
    // console.log('e', e);

    if (e.name === 'required') {
      e.message = '是必填欄位';
      e.params.missingProperty = '此欄位';
    } else if (e.name === 'format') {
      e.message = '需符合正確格式';
    }
    return e;
  });
}

export function disabledSchema(prev) {
  let next = JSON.parse(JSON.stringify(prev));
  for (let key in prev.properties) {
    next.properties[key] = {...next.properties[key], readOnly: true};
  }
  return next;
}

export function validate(schema, formData = {}) {
  let errorList = [];
  for (let key in schema.properties) {
    const property = schema.properties[key];

    // required
    if (
      Array.isArray(schema.required) &&
      schema.required.includes(key) &&
      !formData[key] &&
      formData[key] !== 0
    ) {
      errorList.push(`${property.title || key}為必填欄位`);

      // exists in enum
      if (
        Array.isArray(property.enum) &&
        !property.enum.includes(formData[key])
      ) {
        errorList.push(`${property.title || key}值不在選項中`);
      }
    }

    // nested
    if (property.type === 'object') {
      errorList = errorList.concat(validate(property, formData[key]));
    }
  }

  return errorList;
}
